const REDIRECT_KEY = "auth_redirect_after_login";

export const saveRedirectPath = (pathname, search = "", hash = "") => {
  const full = `${pathname}${search}${hash}`;
  if (
    full &&
    full !== "/login" &&
    !full.includes("://") &&
    !full.startsWith("//")
  ) {
    sessionStorage.setItem(REDIRECT_KEY, full);
  }
};

export const consumeRedirectPath = () => {
  const path = sessionStorage.getItem(REDIRECT_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  return path || null;
};

export const clearRedirectPath = () => {
  sessionStorage.removeItem(REDIRECT_KEY);
};
